import Organization from "../../../model/organization/Organization";

/**
 * Organization fetched action.
 */
export const ORGANIZATION_FETCHED = "ORGANIZATION_FETCHED";
export type ORGANIZATION_FETCHED = { organization: Organization }